import React from 'react';

const OrderPayments = () => {
    return (
        <div className='card shadow'>
            <div className='card-body py-3'>
                <div className='table-responsive'>
                    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                        <thead>
                            <tr className='fw-bold text-muted'>
                                <th className='min-w-120px'>Payment ID</th>
                                <th className='min-w-120px'>Order Id</th>
                                <th className='min-w-120px'>Type</th>
                                <th className='min-w-120px'>User</th>
                                <th className='min-w-120px'>Amount</th>
                                <th className='min-w-120px'>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default OrderPayments;
